@let blok = block();

<div class="block max-w-max"
     [ngClass]="getIconClasses()">
    @if (blok.predefinedIcon && blok.predefinedIcon !== 'unset') {
        <mat-icon
            class="!block !h-16 !w-auto !max-w-16"
            [svgIcon]="blok.predefinedIcon"
            [attr.aria-hidden]="blok.iconDecorative || false"
            [attr.aria-label]="blok.iconDecorative? blok.ariaLabel : null" />
    } @else if (blok.customIcon?.length && blok.customIcon![0].filename) {
        <img class="h-16"
             [src]="blok.customIcon![0]!.filename"
             [alt]="blok.iconDecorative? '' : (blok.customAltText || blok.customIcon![0]!.alt)"
             loading="lazy"
             width="64"
             height="64"
        />
    } @else {
        <div class="w-full h-full flex items-center justify-center">
            <mat-icon
                class="!w-16 !h-16 text-7xl"
                fontIcon="sync"
                [attr.aria-hidden]="blok.iconDecorative || false"
                [attr.aria-label]="blok.iconDecorative? blok.ariaLabel : null" />
        </div>
    }
</div>
